var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-error-message-page col-block",style:({ 'min-height': '200px' })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"message-title",class:[_vm.project.state.replace('created', '') || _vm.caseState, { error: _vm.project.error }],style:(_vm.customContent.style || {}),domProps:{"innerHTML":_vm._s(_vm.customContent.text || ({
      uploading: [
        _vm.$t('COMPONENT.case.errorMessage.___uploading')
      ],
      analyzing: [
        _vm.$t('COMPONENT.case.errorMessage.___analyzing')
      ],
      started: [
        _vm.$t('COMPONENT.case.errorMessage.___analyzing')
      ],
      failed: !_vm.project.error ? [
        _vm.$t('COMPONENT.case.errorMessage.___failed01'),
        _vm.$t('COMPONENT.case.errorMessage.___failed02')
      ] : [
        '<span>' + _vm.$t('COMPONENT.case.errorMessage.___failed03') + '<span>',
        _vm.project.error
      ]
    }[_vm.project.state.replace('created', '') || _vm.caseState] || []).join('<br>'))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f914a6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/case/errorMessage.vue
// module id = null
// module chunks = 